import { useState, useMemo } from "react";

export const useTableSort = (data, defaultSortKey) => {
  const [sortConfig, setSortConfig] = useState({
    key: defaultSortKey || "",
    direction: "asc",
  });

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [data, sortConfig.key, sortConfig.direction]);

  const handleSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });
  };

  return { sortedData, sortConfig, handleSort };
};
